import React from "react";
import { Link } from "react-router-dom";

const Navigation = ({ name }) => {
  const pathnames = window.location.pathname.split("/").filter((x) => x);

  return (
    <nav>
      <ul className="w-full h-[63px] px-[35px] py-[21px] bg-white border-b border-[#e0e0e0] justify-start items-center gap-3.5 inline-flex">
        <li className="text-black text-sm font-semibold font-['Inter'] leading-[21px]">
          <Link to="/dashboard">Dashboard</Link>
        </li>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          return (
            <>
              <li> &gt; </li>
              <li
                key={to}
                className="text-black text-sm font-semibold font-['Inter'] leading-[21px] capitalize"
              >
                {isLast ? <span>{value}</span> : <Link to={to}>{value}</Link>}
              </li>
            </>
          );
        })}
      </ul>
    </nav>
  );
};

export default Navigation;
